import React from "react";

import { compose } from 'redux';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import withShowToast from '../../../hocs/with_show_toast.js';
import withCurrentUser from '../../../hocs/with_current_user.js.jsx';

import I18n from "../../../base/i18n.js.jsx";
import Button from "../../../base/buttons/button.js";
import Checkbox from "../../../base/inputs/checkbox.js";
import Container from "../../../base/components/container.js.jsx";
import HtmlContent from "../../../base/components/html_content.js";
import PersonalInfoFields from "../../../base/user_fields/personal_info_fields.js.jsx";
import EmbedBlock from "./components/embed_block.js";

import CurrentUserUseCase from "../../../use_cases/users/current_user/current_user_use_case.js.jsx";
import UpdateCurrentUserUseCase from "../../../use_cases/users/current_user/update_current_user_use_case.js.jsx";
import CreateUserWebIdUseCase from "../../../use_cases/webid/create_user_webid_use_case.js.jsx";

import Routes from "../../routes.js";

const styles = theme => ({
  root: {
    padding: "185px 0 260px",
    backgroundColor: theme.palette.white,
    ['@media (max-width: 768px)']: {
      padding: "40px 0 65px"
    }
  },
  container: {
    ['@media (max-width: 768px)']: {
      paddingLeft: "24px",
      paddingRight: "24px"
    },
  },
  inner: {
    maxWidth: "980px",
    margin: "auto"
  },
  agreementRow: {
    marginBottom: "30px",
    ['@media (max-width: 768px)']: {
      marginBottom: "22px"
    }
  },
  agreementText: {
    fontSize: "16px",
    ['@media (max-width: 768px)']: {
      fontSize: "11px",
    },
    "& a": {
      color: theme.palette.black
    }
  },
  title: {
    color: theme.palette.gray2,
    fontSize: "32px",
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: "1.35",
    marginBottom: "55px",
    ['@media (max-width: 768px)']: {
      fontSize: "20px",
      marginBottom: "25px",
    }
  },
  desc: {
    fontSize: "20px",
    fontWeight: theme.typography.fontWeightLight,
    lineHeight: "1.5",
    marginBottom: "20px",
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      marginBottom: "15px",
    }
  },
  signature: {
    fontSize: "16px",
    fontWeight: theme.typography.fontWeightLight,
    lineHeight: "1.3",
    ['@media (max-width: 768px)']: {
      fontSize: "12px"
    }
  },
  button: {
    display: "block",
    fontSize: "20px",
    margin: "0 auto 90px",
    maxWidth: "410px",
    padding: "8px 20px",
    width: "100%",
    ['@media (max-width: 768px)']: {
      margin: "0 auto 32px",
      fontSize: "18px",
      padding: "10px 20px",
    }
  }
})

class ProfileIdentifyPage extends React.Component {

  constructor(props) {
    super(props);

    this.item = {}
    this.state = {
      agreement: false,
      showProfileFields: false
    };
  }

  componentDidMount(){
    this.loadUserProfile();
  }

  onItemChange = (changedItem) => {
    this.item = {
      ...this.item,
      ...changedItem
    };
  }

  onAcceptTermsAndConditions = (value) => {
    this.setState({
      agreement: value
    })
  }

  loadUserProfile = () => {
    CurrentUserUseCase.execute()
    .then(result => {
      const { data: { user: { personalInfo } } } = result;

      if(!personalInfo.identityDocument) {
        personalInfo.identityDocument = {};
      }
      if(!personalInfo.address) {
        personalInfo.address = {};
      }
      this.item = personalInfo
    })
    .catch((result) => {
      this.props.showServerErrorIfNeed(result);
    });
  }

  redirectToWebId = url => {
    window.location.href = url
  }

  createUserWebId = () => {
    return CreateUserWebIdUseCase.execute()
    .then(result => {
      const { url } = result.data.userAction
      this.redirectToWebId(url)
    })
  }

  updateUserProfile = () => {
    const params = {
      personalInfo: {
        ...this.item
      }
    }
    return UpdateCurrentUserUseCase.execute(params)
  }

  catchError = error => {
    let { errorData, errorCode } = error;
    if(!Boolean(errorData)) {
      errorData = {};
    }

    let showProfileFields = errorCode === "form";
    let userErrors = undefined;
    if(errorData.user) {
      userErrors = errorData.user;
    }
    else if(errorData.personalInfo) {
      userErrors = errorData;
    }

    this.setState({
      showProfileFields: showProfileFields,
      errorData: userErrors,
      submitting: false
    });

    if(showProfileFields) {
      this.props.showErrorMessage(I18n.t("web.page.identify.error.empty_profile"));
    }
    else {
      this.props.showServerErrorIfNeed(error);
    }
  }

  onClickSubmitButton = event => {
    event.preventDefault();
    const { showProfileFields } = this.state

    this.setState({ submitting: true, errorData: undefined })


    if(showProfileFields) {
      this.updateUserProfile()
      .then(this.createUserWebId)
      .catch(this.catchError)
    }
    else {
      this.createUserWebId()
      .catch(this.catchError)
    }

  }

  render(){
    const { classes, currentUser } = this.props
    const { agreement, showProfileFields, submitting, errorData: { personalInfo: errorData } = {} } = this.state

    return <div className = { classes.root }>
       <Container className = { classes.container }>
        <div className = { classes.inner }>
          <HtmlContent className = { classes.title }>
            { I18n.t("web.page.identify.title", {
               last_name: currentUser.personalInfo.lastName
              })
            }
          </HtmlContent>
          <HtmlContent className = { classes.desc }>
            { I18n.t("web.page.identify.description") }
          </HtmlContent>

          <Checkbox checked = { agreement }
                    onChange = { (value) => this.onAcceptTermsAndConditions(value) }
                    className = { classes.agreementRow }
                    displayName = {
            <HtmlContent className = { classes.agreementText }>
              { I18n.t("web.page.identify.agreement", {terms_and_conditions: Routes.termsAndConditions()}) }
            </HtmlContent>
          }/>
          <EmbedBlock/>
          { showProfileFields &&
            <PersonalInfoFields item = { this.item }
                               errorData = { errorData }
                               onChange = { this.onItemChange } /> }
          <Button className = { classes.button }
                  type = { "submit" }
                  onClick = { this.onClickSubmitButton }
                  disabled = { !agreement || submitting } >
            { I18n.t("action.go_to_web_id") }
          </Button>
          <HtmlContent className = { classes.signature }>
            { I18n.t("web.page.identify.signature") }
          </HtmlContent>
        </div>
      </Container>
    </div>
  }
}

export default compose(withRouter, withCurrentUser, withShowToast, withStyles(styles))(ProfileIdentifyPage)
